import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSectionBase } from '../../Constant/useActiveLibrary';
import { ALL_REPORT_CONFIGS } from './reportConfigs';
import ReportPage from './ReportPage';

// One dynamic route (/librarian/reports/:reportKey, mirrored for /admin and
// /school) instead of 11 near-identical route entries + 11 page files —
// looks the config up by key and hands it to the single shared ReportPage
// shell. An unknown key (bad link, typo) gets a clear message instead of a
// blank page or a crash.
const ReportRouteWrapper = () => {
  const { reportKey } = useParams();
  const sectionBase = useSectionBase();
  const config = ALL_REPORT_CONFIGS.find((c) => c.key === reportKey);

  if (!config) {
    return (
      <div className="container-fluid mt-3">
        <div className="alert alert-warning">
          Unknown report "{reportKey}".{' '}
          <Link to={`${sectionBase}/reports`}>Back to Reports</Link>
        </div>
      </div>
    );
  }

  return <ReportPage config={config} />;
};

export default ReportRouteWrapper;
